export default "__VITE_ASSET__c4571093__"